import { Anchor, Breadcrumbs, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import StoriesDetailsForm from '../../components/Stories/StoriesDetailsForm';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const StoriesDetailsPage = () => {
  const page = `${Page.stories}`;
  const location = useLocation();
  const navigate = useNavigate();
  const fetch = useFetch();

  const [loadError, setLoadError] = useState();
  const [story, setStory] = useState();
  const { accountId, domainId, id } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/stories/${id}`)
      .then(({ story }) => {
        if (!story) {
          navigate(`/accounts/${accountId}/domains/${domainId}/stories`);
        }
        setStory(story);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, id]);

  const goBack = () => {
    navigate(`/accounts/${accountId}/domains/${domainId}/stories`);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (story === undefined) {
    return <Spinner />;
  }

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/stories/${story.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        goBack();
      })
      .catch(setLoadError);
  };

  return (
    <>
      <Metadata title={`${page} | ${story.name} | Edit`} />
      <Breadcrumbs mb="md">
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/analytics`}>Home</Anchor>
        <Anchor href={`#/accounts/${accountId}/domains/${domainId}/stories`}>Stories</Anchor>
        <Anchor href={`#${location.pathname.replace('details', 'analytics')}`}>{story.name}</Anchor>
        <Text>Edit</Text>
      </Breadcrumbs>
      <StoriesDetailsForm
        story={story}
        onSuccess={goBack}
        onBack={goBack}
        onCopy={() => navigate(`/accounts/${accountId}/domains/${domainId}/stories/new?from=${id}`)}
        del={del}
      />
    </>
  );
};

export default StoriesDetailsPage;
